import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { CountryFlagImage, CountryFlagSVG, CountryName, ExpDateSlash, FormColumnWrapper, FormInput, FormInputHeader, FormRowWrapper, MopActionSection, MopDetailsContainer, MopDetailsSection } from './styled';
import { MopCheckboxSection } from './MopCheckboxSection';
import { LinkWrapper } from '../../PaymentForm/styled';
import { Button } from '@chegg-ui/button';
import { Link } from '@chegg-ui/link';
import { ChevronIcon } from '@chegg-ui/theme';
import { AppProductionConfigs, Zipcode } from '../../../constants/AppConstants';
import { CardTypes, WalletMOP } from '../../../constants/PaymentTypes';
import { DataTestAttributes } from '../../../constants/DataTestAttributes';
import { getString } from '../../../constants/Strings';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { configSelector } from '../../../redux/ConfigState/ConfigState.selectors';
import { getPaymentFieldLabelText } from '../../PaymentForm/helpers';
import { PaymentFormDataFields } from '../../UserAddress/constants';
import { SubType, ElementType, SpecType, StatusTypes, Component, PaymentMethodsCommandNames, sendRioEvent, ValidationManager, getCountryName } from '@chegg/commerce-utils';
import { sendRioEventCallback, doFireStatusUpdate } from '../../../utils/CallbackUtils';
import { ERRORS } from '../../../constants/Errors';
import useUpdateRecurlyMop from '../../../hooks/useUpdateRecurlyMop';
var types = ValidationManager.types;
var CCFIELDS = types.CCFIELDS;
var MopDetailsItem = function MopDetailsItem(props) {
  var _billingAddress$count;
  var config = useAppSelector(configSelector);
  var isCheckboxUpdated = config.isCheckboxUpdated,
    paymentForm = config.paymentForm,
    rioNamespace = config.rioNamespace;
  var backupMop = props.backupMop,
    primaryMop = props.primaryMop,
    isMultipleMop = props.isMultipleMop,
    mop = props.mop,
    onChangeIndex = props.onChangeIndex;
  var accountType = mop.accountType,
    billingAddress = mop.billingAddress,
    cardId = mop.cardId,
    isBackup = mop.isBackup,
    isPrimary = mop.isPrimary,
    month = mop.month,
    type = mop.type,
    year = mop.year;
  var _useState = useState(!!isPrimary),
    _useState2 = _slicedToArray(_useState, 2),
    isDefaultChecked = _useState2[0],
    setIsDefaultChecked = _useState2[1];
  var _useState3 = useState(!!isBackup),
    _useState4 = _slicedToArray(_useState3, 2),
    isBackUpChecked = _useState4[0],
    setIsBackUpChecked = _useState4[1];
  var _useUpdateRecurlyMop = useUpdateRecurlyMop({
      mopId: '',
      isPrimary: false,
      isBackup: false
    }),
    updateRecurlyMopForMopId = _useUpdateRecurlyMop.updateRecurlyMopForMopId;
  useEffect(function () {
    // Revert back to default checkbox settings
    if (cardId === primaryMop.cardId) {
      setIsDefaultChecked(true);
      setIsBackUpChecked(false);
    }
    if (cardId === (backupMop === null || backupMop === void 0 ? void 0 : backupMop.cardId)) {
      setIsDefaultChecked(false);
      setIsBackUpChecked(true);
    }
  }, [cardId]);
  var cardholderName = "".concat(billingAddress.fname, " ").concat(billingAddress.lname);
  var country = (_billingAddress$count = billingAddress.country) !== null && _billingAddress$count !== void 0 ? _billingAddress$count : '';
  var fullCountryName = getCountryName(country);
  var countryFlagUrl = "".concat(AppProductionConfigs.flagUrl).concat(country.toLocaleLowerCase(), ".svg");
  var zipcode = billingAddress.zip && ![Zipcode.ABCDE, Zipcode.GB].includes(billingAddress.zip) ? billingAddress.zip : '';

  // Recurly doese not store CVV value, so we rely on * based on the number of CVV digits.
  // American Express has a 4-digit CVV while others have a 3-digit CVV.
  var CvvDigit = type === CardTypes.AMERICANEXPRESS ? '****' : '***';
  var isWalletMop = WalletMOP.includes(accountType);
  function onUpdateClick(_x) {
    return _onUpdateClick.apply(this, arguments);
  }
  function _onUpdateClick() {
    _onUpdateClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            sendRioEvent({
              info: getString("APP.RIO.EVENTS.EL_NAME.CARD_CTA_CLICKED_UPDATE"),
              specType: SpecType.INTERACTION,
              subType: SubType.CLICK,
              elementType: ElementType.BUTTON,
              callback: sendRioEventCallback,
              namespace: rioNamespace
            });
            _context.prev = 2;
            _context.next = 5;
            return updateRecurlyMopForMopId({
              mopId: cardId,
              isPrimary: isDefaultChecked,
              isBackup: isBackUpChecked
            });
          case 5:
            if (!(isPrimary && backupMop)) {
              _context.next = 10;
              break;
            }
            _context.next = 8;
            return updateRecurlyMopForMopId({
              // if it's a primary card originally, update previous backup MOP to primary
              mopId: backupMop.cardId,
              isPrimary: true,
              isBackup: false
            });
          case 8:
            _context.next = 13;
            break;
          case 10:
            if (!isBackup) {
              _context.next = 13;
              break;
            }
            _context.next = 13;
            return updateRecurlyMopForMopId({
              mopId: primaryMop.cardId,
              isPrimary: false,
              isBackup: true
            });
          case 13:
            if (onChangeIndex) {
              onChangeIndex(-1);
            }
            _context.next = 19;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](2);
            doFireStatusUpdate([{
              status: StatusTypes.ERROR,
              command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
              payload: {
                component: Component.PAYMENT_METHODS_CALLBACK,
                errors: [ERRORS.PAYMENT_PROCESSING_ERROR]
              }
            }]);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 16]]);
    }));
    return _onUpdateClick.apply(this, arguments);
  }
  function onCancelClick(_x2) {
    return _onCancelClick.apply(this, arguments);
  }
  function _onCancelClick() {
    _onCancelClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            event.preventDefault();
            if (onChangeIndex) {
              onChangeIndex(-1);
            }
            if (isCheckboxUpdated) {
              setIsDefaultChecked(!!isPrimary);
              setIsBackUpChecked(!!isBackup);
            }
            sendRioEvent({
              info: getString("APP.RIO.EVENTS.EL_NAME.CANCEL_PAYMENT_METHOD_CLICKED_'EDIT"),
              specType: SpecType.INTERACTION,
              subType: SubType.CLICK,
              elementType: ElementType.BUTTON,
              callback: sendRioEventCallback,
              namespace: rioNamespace
            });
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _onCancelClick.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(MopDetailsContainer, null, !isWalletMop && /*#__PURE__*/React.createElement(MopDetailsSection, {
    "data-test": DataTestAttributes.CREDIT_CARD_FORM_CONTAINER
  }, /*#__PURE__*/React.createElement(FormRowWrapper, null, /*#__PURE__*/React.createElement(FormInputHeader, null, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.NAME_ON_THE_CARD) || getString('APP.FORM.LABEL.NAME')), /*#__PURE__*/React.createElement(FormInput, {
    id: CCFIELDS.CARDHOLDER_NAME
  }, cardholderName)), /*#__PURE__*/React.createElement(FormColumnWrapper, null, /*#__PURE__*/React.createElement(FormRowWrapper, null, /*#__PURE__*/React.createElement(FormInputHeader, null, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.EXP_DATE_MMYYYY) || getString('APP.FORM.LABEL.EXPIRATION.DATE')), /*#__PURE__*/React.createElement(FormColumnWrapper, {
    className: 'expiration-date'
  }, /*#__PURE__*/React.createElement(FormInput, {
    id: CCFIELDS.EXPIRATION_MONTH
  }, month), /*#__PURE__*/React.createElement(ExpDateSlash, null, "/"), /*#__PURE__*/React.createElement(FormInput, {
    id: CCFIELDS.EXPIRATION_YEAR
  }, year))), /*#__PURE__*/React.createElement(FormRowWrapper, null, /*#__PURE__*/React.createElement(FormInputHeader, null, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.CVV) || getString('APP.FORM.LABEL.CVV')), /*#__PURE__*/React.createElement(FormInput, {
    id: CCFIELDS.CVV
  }, CvvDigit))), /*#__PURE__*/React.createElement(FormColumnWrapper, null, /*#__PURE__*/React.createElement(FormRowWrapper, null, /*#__PURE__*/React.createElement(FormInputHeader, null, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.COUNTRY) || getString('APP.FORM.LABEL.COUNTRY')), /*#__PURE__*/React.createElement(FormInput, {
    id: 'country'
  }, /*#__PURE__*/React.createElement(CountryFlagSVG, null, /*#__PURE__*/React.createElement(CountryFlagImage, {
    href: countryFlagUrl
  })), /*#__PURE__*/React.createElement(CountryName, null, fullCountryName), /*#__PURE__*/React.createElement(ChevronIcon, {
    id: 'icon-story-Caret',
    role: 'img',
    "aria-hidden": true,
    iconFill: "fill",
    pointing: 'down',
    size: 'xsmall'
  }))), /*#__PURE__*/React.createElement(FormRowWrapper, null, /*#__PURE__*/React.createElement(FormInputHeader, null, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.ZIP_POSTAL) || getString('APP.FORM.LABEL.ZIP.POSTAL.CODE')), /*#__PURE__*/React.createElement(FormInput, {
    id: CCFIELDS.BILLING_ZIP
  }, zipcode)))), /*#__PURE__*/React.createElement(MopCheckboxSection, {
    isBackup: !!isBackup,
    isPrimary: !!isPrimary,
    isMultipleMop: isMultipleMop,
    isDefaultChecked: isDefaultChecked,
    isBackUpChecked: isBackUpChecked,
    setIsDefaultChecked: setIsDefaultChecked,
    setIsBackUpChecked: setIsBackUpChecked
  }), /*#__PURE__*/React.createElement(MopActionSection, {
    "data-test": DataTestAttributes.MOP_CTA_CONTAINER
  }, /*#__PURE__*/React.createElement(LinkWrapper, null, /*#__PURE__*/React.createElement(Link, {
    "data-test": DataTestAttributes.CANCEL_BUTTON,
    className: 'mop-details-cancel-button',
    hasButtonBehavior: true,
    onClick: onCancelClick,
    href: '#',
    role: 'button'
  }, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.CANCEL) || getString('APP.MOPONFILE.CANCEL'))), /*#__PURE__*/React.createElement(Button, {
    "data-test": DataTestAttributes.UPDATE_BUTTON,
    className: "mop-details-update-button",
    onClick: onUpdateClick,
    disableHoverAnimation: true
  }, /*#__PURE__*/React.createElement("span", null, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.UPDATE) || getString('APP.MOPONFILE.UPDATE')))));
};
export default /*#__PURE__*/React.memo(MopDetailsItem);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Recurly/MopListView/MopDetailsItem.js
// module id = 4642
// module chunks = 11